import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  SimpleChanges,
} from '@angular/core';
import { MessageService } from 'primeng/api';
import { HardCopyActivityService } from '../../../hard-copy/services/hard-copy-activity.service';
import { UpdateHardcopyActivityDTO } from '../../../hard-copy/models/update-hardcopy-activity-DTO';
import { MyHardCopyConstants } from '../../my-hard-copy-constants';
import { MyHardCopyService } from '../../services/my-hard-copy.service';

@Component({
  selector: 'app-my-hard-copy-confirmation',
  templateUrl: './my-hard-copy-confirmation.component.html',
  styleUrls: ['./my-hard-copy-confirmation.component.scss'],
})
export class MyHardCopyConfirmationComponent implements OnInit {
  @Input() hardcopyActivityId: any;
  @Input() removeActivity: any;
  @Input() removedCopiesMax: any;
  @Output() closeConfirmationModal = new EventEmitter<boolean>();
  @Input() closeConfirmationModalVisible!: boolean;
  constructor(
    private hardCopyActivityService: HardCopyActivityService,
    private messageService: MessageService,
    private cd: ChangeDetectorRef,
    private myHardCopyService:MyHardCopyService
  ) {}
  display: boolean = true;
  displayConfirmationDialog: boolean = false;
  removedCopiesVal: any;
  removedCopies: any;
  maxRemovedCopies: any;
  updateHardcopyData!: UpdateHardcopyActivityDTO;
  maxValueLimit!: number;

  ngOnInit(): void {
    this.displayConfirmationDialog = false;
    this.maxValueLimit = this.removedCopiesMax;
    this.updateHardcopyData = {
      Removedcopies: null,
    };
  }

  ngOnChanges(changes: SimpleChanges) {
    for (let property in changes) {
      this.maxValueLimit = this.removedCopiesMax;
    }
  }

  confirmClick(buttonClick: any): void {
    if (this.removeActivity) {
      this.updateHardcopyData.Removedcopies = this.removedCopiesMax;
    } else {
      this.updateHardcopyData.Removedcopies = null;
    }
    this.hardCopyActivityService
      .updateHardcopyActivity(this.hardcopyActivityId, this.updateHardcopyData)
      .subscribe((serviceData) => {
        this.messageService.add({
          severity: MyHardCopyConstants.Severity_Info,
          summary: MyHardCopyConstants.MyHardCopyActivity_Completed_Success,
        });
        this.myHardCopyService.hardcopyActivityCompleted.next('true');
        this.cd.detectChanges();
        this.reloadHardCopyDetail();
      });
  }

  reloadHardCopyDetail(): void {
    this.closeConfirmationModalVisible = false;
    this.closeConfirmationModal.emit(this.closeConfirmationModalVisible);
  }

  cancelClick(): void {
    this.closeConfirmationModalVisible = false;
    this.closeConfirmationModal.emit(this.closeConfirmationModalVisible);
  }

  onCopiesChanges(keyEvent: any) {
    if (Number(keyEvent.target.value) < 1) {
      keyEvent.target.value = 1;
    }
    if (Number(keyEvent.target.value) > this.removedCopiesMax) {
      keyEvent.target.value = this.removedCopiesMax;
    } else {
      this.removedCopiesMax = keyEvent.target.value;
    }
  }
}
